import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgCloseIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 3L3 13", strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 13L3 3", strokeLinecap: "round" }));
});
export default SvgCloseIcon;
